import dynamic from 'next/dynamic';
import { EventHeadingProps } from './EventHeading.types';

export const EventHeading = dynamic<{ model: EventHeadingProps }>(() =>
  import('./EventHeading').then(mod => mod.EventHeading)
);
